import React from 'react'
import UIBody from '../../../components/ui/UIBody'
import CaseSection from './CaseSection'
// import useApiCallHooks from '../../../hooks/useApiCallHooks';

const CaseStudyPage = () => {
//  const [responce, loading, error, callAPI, statusCode] = useApiCallHooks();

  return (
   <UIBody
  //  loading={loading}
   content={
    <div> 
 <section class="cta__area-four">
            <div class="container">
              <div class="row justify-content-center">
                <div class="col-xl-10">
<div
  className="cta__inner-wrap mt-4"
  style={{
                           background: 'linear-gradient(90deg, rgba(2, 0, 36, 1) 0%, rgba(9, 9, 121, 1) 22%, rgba(0, 212, 255, 1) 100%)',

    borderRadius: '20px',
    // padding: '40px',
    color: '#fff' // ensures text is readable
  }}
>
 <div class="cta__img-three tg-svg " >
                      <img
                        src="https://html.themegenix.com/skillgro/assets/img/others/h8_cta_img.png"
                        alt="img"
                      />
                      <span
                        class="svg-icon"
                        id="cta-svg"
                        data-svg-icon="assets/img/others/h8_cta_img_shape.svg"
                      ></span>
                    </div>

  <div className="cta__content-three cta__content-four">
    <div className="content__left">
      <h2 className="title text-center"  >Crafting Digital Experiences</h2>
      <p>
          Explore our collection of case studies showcasing innovative solutions
    that drive real business results. 
      </p>
    </div>
  </div>

  <img
    src="assets/img/others/h8_cta_shape.svg"
    alt="shape"
    className="shape"
  />
</div>


</div>

              </div>
            </div>
          </section>

    <CaseSection/></div>
    
   }/>
   
  )
}

export default CaseStudyPage
